<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动金币配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:activityCoins:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:activityCoins:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="关卡">
              <el-input v-model.number="item.levelId" size="mini" style="width: 50px;" placeholder="关卡" />
            </el-form-item>
            <el-form-item label="收集">
              <el-input v-model.number="item.collect" size="mini" style="width: 80px;" placeholder="收集" />
            </el-form-item>
            <el-form-item label="打">
              <el-input v-model.number="item.attack" size="mini" style="width: 80px;" placeholder="打" />
            </el-form-item>
            <el-form-item label="偷">
              <el-input v-model.number="item.steal" size="mini" style="width: 80px;" placeholder="偷" />
            </el-form-item>
            <el-form-item label="排行榜">
              <el-input v-model.number="item.rank" size="mini" style="width: 80px;" placeholder="排行榜" />
            </el-form-item>
            <!--            <el-form-item label="宝藏目标值">-->
            <!--              <el-input v-model.number="item.treasureCollect" size="mini" style="width: 80px;" placeholder="宝藏目标值" />-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="宝藏金币值">-->
            <!--              <el-input v-model.number="item.treasureReward" size="mini" style="width: 80px;" placeholder="宝藏金币值" />-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="宝藏下注值">-->
            <!--              <el-input v-model.number="item.treasureBet" size="mini" style="width: 80px;" placeholder="宝藏下注值" />-->
            <!--            </el-form-item>-->
            <el-form-item label="星星兑换">
              <el-input v-model.number="item.starExchange" size="mini" style="width: 80px;" placeholder="星星兑换" />
            </el-form-item>
            <el-form-item label="建筑大师">
              <el-input v-model.number="item.architecture" size="mini" style="width: 80px;" placeholder="建筑大师" />
            </el-form-item>
            <el-form-item label="累冲">
              <el-input v-model.number="item.accumulated_pay" size="mini" style="width: 80px;" placeholder="累冲" />
            </el-form-item>
            <el-form-item label="超级连环礼包">
              <el-input v-model.number="item.super_serial_pack" size="mini" style="width: 80px;" placeholder="超级连环礼包" />
            </el-form-item>
            <el-form-item label="推金币">
              <el-input v-model.number="item.coin_dozer" size="mini" style="width: 80px;" placeholder="推金币" />
            </el-form-item>
            <el-form-item label="超级气球">
              <el-input v-model.number="item.super_balloon" size="mini" style="width: 80px;" placeholder="超级气球" />
            </el-form-item>
            <el-form-item label="复活彩蛋">
              <el-input v-model.number="item.easter_egg" size="mini" style="width: 80px;" placeholder="复活彩蛋" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:activityCoins:del']" type="danger" @click="del(index, item.levelId)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:activityCoins:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:activityCoins:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delActivityCoinCfg,
  exportActivityCoinCfg,
  getActivityCoinCfgList,
  importActivityCoinCfg,
  updateActivityCoinCfg
} from '@/api/config/activity-coin-cfg'
export default {
  name: 'ActivityCoins',
  data() {
    return {
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'levelId': 0,
          'collect': 0,
          'attack': 0,
          'steal': 0,
          'rank': 0,
          'treasureCollect': 0,
          'treasureReward': 0,
          'treasureBet': 0,
          'starExchange': 0,
          'architecture': 0,
          'accumulated_pay': 0,
          'super_serial_pack': 0,
          'coin_dozer': 0,
          'super_balloon': 0,
          'easter_egg': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateActivityCoinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivityCoinCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'collect': 0,
        'attack': 0,
        'steal': 0,
        'rank': 0,
        'treasureCollect': 0,
        'treasureReward': 0,
        'treasureBet': 0,
        'starExchange': 0,
        'architecture': 0,
        'accumulated_pay': 0,
        'super_serial_pack': 0,
        'coin_dozer': 0,
        'super_balloon': 0,
        'easter_egg': 0
      })
    },
    del(key, id) {
      delActivityCoinCfg({ id: id }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivityCoinCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      importActivityCoinCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
